import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classnames from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';

import { InteractablePopover } from 'ui-components/components/interactable-popover';

import { FormattedMessagePropType } from '../../prop-types/intl';
import { WARNING_SEVERITY, ERROR_SEVERITY } from './constants';

import style from './style.module.css';

export const CompactError = ({
  errorMessages,
  severity = WARNING_SEVERITY,
  className = '',
  title,
  displayIconText = true,
  ignoreTooltip = false,
  ignoreFlyout = false,
  preferPlace = 'top',
}) => {
  const isErrorSeverity = severity === ERROR_SEVERITY;
  const iconClassName = severity === ERROR_SEVERITY ? ERROR_SEVERITY : WARNING_SEVERITY;

  const body = useMemo(
    () =>
      errorMessages.map((message, index) => {
        if (typeof message === 'string') {
          return <div key={index}>{message}</div>;
        }
        return (
          <div key={index}>
            <FormattedMessage {...message} />
          </div>
        );
      }),
    [errorMessages],
  );

  return (
    <InteractablePopover
      ignoreFlyout={ignoreFlyout ?? isErrorSeverity}
      ignoreTooltip={ignoreTooltip ?? !isErrorSeverity}
      popoverBody={body}
      preferPlace={preferPlace}
      title={title}
    >
      <div className={classnames(style[className], style[iconClassName])}>
        <div className={style['error-icon-wrapper']}>
          <FontAwesomeIcon icon={isErrorSeverity ? faExclamationCircle : faExclamationTriangle} />
        </div>
        {isErrorSeverity && (
          <span className={style['error-text']}>
            <FormattedMessage defaultMessage='Error' description='compactError.error' id='pP/woq' />
          </span>
        )}

        {displayIconText && !isErrorSeverity && <div className={style['warning-text']}>{title}</div>}
      </div>
    </InteractablePopover>
  );
};

CompactError.propTypes = {
  errorMessages: PropTypes.arrayOf(PropTypes.any).isRequired,
  severity: PropTypes.oneOf([WARNING_SEVERITY, ERROR_SEVERITY]),
  className: PropTypes.string,
  title: FormattedMessagePropType.isRequired,
  displayIconText: PropTypes.bool,
  ignoreTooltip: PropTypes.bool,
  ignoreFlyout: PropTypes.bool,
  preferPlace: PropTypes.string,
};
